import { Controller } from "@hotwired/stimulus";
import { refreshPurchaseMobileCard } from "../../purchase_invoices/purchase_invoice_channel/mobile_card_processing";

export default class extends Controller {
  connect() {
    document.addEventListener("purchaseInvoice:updated", (e) => {
      const purchaseInvoice = e.detail.purchaseInvoices[0];
      refreshPurchaseMobileCard(purchaseInvoice);

      document.dispatchEvent(new CustomEvent("sidePanel:close"));
    });
  }
}
